import script from "./PersonMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonMessage.vue?vue&type=script&setup=true&lang=js"

import "./PersonMessage.vue?vue&type=style&index=0&id=25f53089&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f53089"]])

export default __exports__